import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const PhotoBlock = ({ data }) => {
  const imgBlock = data?.PhotoBlockGroup;
  return (
    <section className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto lg:my-20 xl:p-0 p-5 lg:mb-20">
      <div className="grid sm:grid-cols-3 gap-4 my-12 justify-center lg:mt-24">
        {imgBlock?.map((img, index) => {
          const imageObject = getImage(img.PhotoBlock.localFile);
          return (
            <GatsbyImage
              image={imageObject}
              alt="block image"
              key={index}
              className=" rounded-lg"
            />
          );
        })}
      </div>
    </section>
  );
};

export default PhotoBlock;
